const pclnGptDartAds = [
  {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile',
    gptDivId: 'div-gpt-ad-1447089861109-0',
    adSize: [320, 50],
  },
  {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile_2',
    gptDivId: 'div-gpt-ad-1447090052411-0',
    adSize: [320, 50],
  },
  {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile_3',
    gptDivId: 'div-gpt-ad-1447090103302-0',
    adSize: [320, 50],
  },
  {
    adUnitPath: '/3102/priceline.dart/air_fare_results_mobile_4',
    gptDivId: 'div-gpt-ad-1447090172253-0',
    adSize: [320, 50],
  },
  {
    gptDivId: 'div-gpt-ad-1621948623733-0',
    adUnitPath: '/3102/priceline.dart/priceline_flight_cpc_inline',
  },
]

export { pclnGptDartAds }
